import React from "react";
import Ink from "react-ink";
import {useNavigate} from "react-router-dom";
import PWAInstallation from "../PWAInstallation";

const Nav = (props) => {
    const navigate = useNavigate();
    const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
    const herocolor = localStorage.getItem("herocolor");

    const address = userSetAddress?.address || "";

    const addressParts = address.split(",");

    const firstLine = addressParts[0] || "";
    const secondLine = addressParts.slice(1).join(",").trim();


    return (
        <React.Fragment>
            <div
                style={{
                    position: "absolute",
                    top: "6%",
                    zIndex: 2,
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "0 10px"
                }}
            >

                <div style={{width: "100%", maxWidth: "40%", zIndex: 4, pa: 10}}>
                    <img
                        src={require("../../../assets/logot.png")}
                        alt={localStorage.getItem("storeName")}
                        style={{width: "100%", maxWidth: "110px", zIndex: 4}}
                    />
                </div>

                <PWAInstallation type="header"/>

                <div
                    onClick={() => navigate("/search-location")}
                    style={{
                        flexWrap: "nowrap",
                        borderRadius: 14,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-end",
                        alignSelf: "flex-end",
                        maxWidth: "60%"
                    }}
                >


                    <div style={{
                        color: herocolor ? herocolor : "#fff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                        fontSize: 14,
                        fontFamily: "'Inter', sans-serif",
                        paddingLeft: 10,
                        fontWeight: "900"
                    }}>
                        <img src={require("../../../assets/placeholder.png")} style={{width: 18, height: 18}}
                             alt={"location"}/>
                        {firstLine || "Search your location"}
                    </div>


                    <div
                        style={{
                            color: herocolor ? herocolor : "#fff",
                            filter: "brightness(0.95)",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "90%",
                            fontSize: 13,
                            paddingLeft: 10,
                            fontWeight: "600"
                        }}
                    >
                        {secondLine || "Tap to set address"}
                    </div>
                </div>

            </div>

            <Ink duration="500"/>


        </React.Fragment>
    );
};

export default Nav;